<template>
    <v-menu
        v-model="timePickerOpen"
        :close-on-content-click="false"
        location="bottom start"
    >
        <template #activator="{ props: timePickerActivatorProps }">
            <AppTextField
                v-bind="timePickerActivatorProps"
                class="picker-control"
                :model-value="modelValue"
                :label="label"
                :placeholder="placeholder"
                :name="name"
                :width="width"
                :required="required"
                :disabled="disabled"
                :readonly="true"
                :hide-details="hideDetails"
                append-inner-icon="mdi-clock-outline"
            />
        </template>

        <v-card
            class="time-field__picker"
            rounded="lg"
        >
            <v-time-picker
                color="primary"
                format="24hr"
                hide-header
                :model-value="modelValue"
                @update:model-value="setSelectedTime"
            />
        </v-card>
    </v-menu>
</template>

<script setup>
import { ref } from 'vue'

import AppTextField from './AppTextField.vue'

defineProps({
  modelValue: {
    type: String,
    default: '',
  },

  label: {
    type: String,
    default: '',
  },

  placeholder: {
    type: String,
    default: '',
  },

  name: {
    type: String,
    default: '',
  },

  width: {
    type: [String, Number],
    default: '100%',
  },

  required: {
    type: Boolean,
    default: false,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  hideDetails: {
    type: [Boolean, String],
    default: 'auto',
  },
})

const emit = defineEmits(['update:modelValue'])
const timePickerOpen = ref(false)

function setSelectedTime (time) {
  emit('update:modelValue', time || '')

  if (time) {
    timePickerOpen.value = false
  }
}
</script>

<style
    scoped
    lang="scss"
>
.time-field {
    &__picker {
        overflow: hidden;
    }
}
</style>
